import React from 'react'
import { trans } from '../../../../_providers/Translation'

function FilterEmployees(props) {

    return (
        <form className="filter-standard">

            <div className="col">
                <input
                    type="search"
                    name="name"
                    onKeyUp={(e) => props.handleSearch(e.target.name, e.target.value)}
                    onChange={(e) => props.handleSearch(e.target.name, e.target.value)}
                    placeholder={trans('labels.name')}
                    value={props.filters.name}
                />
            </div>

            <div className="col">
                <select
                    name="role_id"
                    onKeyUp={(e) => props.handleSearch('role_id', e.target.value)}
                    onChange={(e) => props.handleSearch('role_id', e.target.value)}
                    value={props.filters.role_id}
                >
                    <option value="">Всички роли</option>
                    {props.roles.map(r =>
                        <option key={'r-' + r.id} value={r.id}>
                            {r.translation.name}
                        </option>
                    )}
                </select>
            </div>

        </form>
    )
}

export default FilterEmployees